import React from "react";
import { EwayBillListType } from "../../../redux/listing/listingTypes";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import EwayBillTableData from "./EwayBillTableData";

type AppProps = {
  data: EwayBillListType[] | [];
  tableHeaders: TableHeadersType[] | [];
};

const EwayBillTable = ({ data, tableHeaders }: AppProps) => {
  return <EwayBillTableData data={data} tableHeaders={tableHeaders} />;
};

export default EwayBillTable;
